import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function HotUpdateGrid() {
  const mainComic = featuredComics[0];
  const gridComics = featuredComics.slice(1, 5);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading tracking-wide">
              本周热门 &amp; 新鲜上架
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md leading-relaxed">
            每日精选最新最热的韩国漫画，实时同步韩网更新，让您第一时间追更心仪作品。
          </p>
        </div>

        {/* Grid: 3 columns - left large, middle+right smaller */}
        <div className="grid grid-cols-1 md:grid-cols-[1.2fr_1fr_1fr] gap-5 md:gap-6">
          {/* Left: Large featured card */}
          <Link
            to={`/comic/${mainComic.id}`}
            className="group relative bg-foreground-950 rounded-2xl overflow-hidden cursor-pointer h-[420px] md:h-[500px]"
          >
            <img
              src={mainComic.cover}
              alt={mainComic.title}
              title={mainComic.title}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <div className="flex items-center gap-2 mb-2">
                {mainComic.isHot && (
                  <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    热门
                  </span>
                )}
                {mainComic.isNew && (
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    新作
                  </span>
                )}
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-background-50 font-heading">
                {mainComic.title}
              </h3>
              <p className="text-sm text-background-50/70 mt-1.5 line-clamp-2">
                {mainComic.description}
              </p>
              <p className="text-xs text-background-50/50 mt-3">
                {mainComic.author} · {mainComic.latestChapter}
              </p>
            </div>
          </Link>

          {/* Middle + Right: 2 columns of smaller cards */}
          {gridComics.slice(0, 2).map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={comic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-accent-500/90 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    <i className="ri-time-line text-xs"></i>
                    今日更新
                  </span>
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-base font-semibold text-foreground-900 font-heading group-hover:text-primary-500 transition-colors">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1.5">
                  {comic.author} · {comic.latestChapter}
                </p>
                <div className="mt-auto pt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">评分 {comic.rating}</span>
                  <span className="text-xs text-accent-500 font-medium">
                    {comic.status}
                  </span>
                </div>
              </div>
            </Link>
          ))}

          {/* Row 2: two more cards */}
          {gridComics.slice(2, 4).map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer flex flex-col md:col-span-1"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={comic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                {comic.isNew && (
                  <div className="absolute top-3 left-3">
                    <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                      <i className="ri-sparkling-line text-xs"></i>
                      新上架
                    </span>
                  </div>
                )}
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-base font-semibold text-foreground-900 font-heading group-hover:text-primary-500 transition-colors">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1.5">
                  {comic.author} · {comic.latestChapter}
                </p>
                <div className="mt-auto pt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">评分 {comic.rating}</span>
                  <span className="text-xs text-accent-500 font-medium">
                    {comic.status}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View all link */}
        <div className="mt-10 text-center">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-600 text-background-50 rounded-full text-sm font-medium hover:bg-primary-700 transition-all whitespace-nowrap cursor-pointer"
          >
            查看全部作品
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}